import { render } from "./indexModal.vue?vue&type=template&id=ab80132e"
import script from "./indexModal.vue?vue&type=script&lang=js"
export * from "./indexModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__